export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/definitions/distributors', 'admin.distributors')
    .when('/admin/definitions/quiz', 'admin.quiz')
    .when('/admin/definitions/tools', 'admin.tools')
    .when('/admin/definitions/applications', 'admin.applications')
    .when('/admin/definitions/applications/:id/info', 'admin.application-info')
    .when('/admin/definitions/applications/:id/installations', 'admin.application-installations')

    .within('admin')

    .segment('distributors', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.definitions'
      }],
      template: '<admin-distributors-page></admin-distributors-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-distributors.module" */ "./distributors/admin-distributors.module");
      }
    })

    .segment('quiz', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.definitions'
      }],
      template: '<admin-quiz-page></admin-quiz-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-quiz.module" */ "./quiz/admin-quiz.module");
      }
    })

    .segment('tools', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.definitions'
      }],
      template: '<admin-tools-page></admin-tools-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-tools.module" */ "./tools/admin-tools.module");
      }
    })

    .segment('applications', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.definitions'
      }],
      template: '<admin-applications-page></admin-applications-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-applications.module" */ "./applications/admin-applications.module");
      }
    })

    .segment('application-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.definitions',
          url: '/admin/definitions/applications'
        },
        {
          label: 'admin.breadcrumb.application_info'
        }
      ],
      template: '<admin-application-info-page></admin-application-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-application-info.module" */ "./application-info/admin-application-info.module");
      }
    })

    .segment('application-installations', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.definitions',
          url: '/admin/definitions/applications'
        },
        {
          label: 'admin.breadcrumb.application_info'
        }
      ],
      template: '<admin-application-installations-page></admin-application-installations-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-application-installations.module" */ "./application-installations/admin-application-installations.module");
      }
    });
}
